import React from 'react';

import { Flex, Grid, GridItem } from '@chakra-ui/react';
import styled from '@emotion/styled';
import parse from 'html-react-parser';

import { REVIEW_ANSWER_TYPE_MAP } from 'constants/ProjectConstants';

import { ResultScaleRating } from 'uiToolkitV1/ResultScaleRating/ResultScaleRating';
import { ResultStarRating } from 'uiToolkitV1/ResultStarRating/ResultStarRating';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const AnswerContainer = styled('div')`
  margin-bottom: 16px;
`;

export const ANSWER_TYPE_COMPONENTS = {
  [REVIEW_ANSWER_TYPE_MAP.DROP_DOWN]: {
    component: ({ selectedAnswerOptions = [] }) => {
      const { description } = selectedAnswerOptions[0] ?? {};

      return (
        <Flex flexDir="column">
          <TextLabel bold color="text.g2">
            Assessment
          </TextLabel>
          <TextBodyMedium bold>{description}</TextBodyMedium>
          <TextBodyMedium bold>{selectedAnswerOptions.length === 0 && 'No Feedback'}</TextBodyMedium>
        </Flex>
      );
    },
  },
  [REVIEW_ANSWER_TYPE_MAP.MULTI_SELECT]: {
    component: ({ selectedAnswerOptions = [] }) => (
      <Flex flexDir="column">
        <TextLabel bold color="text.g2">
          Assessment
        </TextLabel>
        <TextBodyMedium bold>
          {selectedAnswerOptions.map(({ description }) => description).join(', ')}
          {selectedAnswerOptions.length === 0 && 'No Feedback'}
        </TextBodyMedium>
      </Flex>
    ),
  },
  [REVIEW_ANSWER_TYPE_MAP.STAR_RATING]: {
    component: ({ selectedAnswerOptions = [], answerOptions = [] }) => (
      <Flex flexDir="column" gap={2}>
        <TextLabel bold color="text.g2">
          Assessment
        </TextLabel>
        <Flex alignItems="center">
          <ResultStarRating maxRating={answerOptions?.length} rating={selectedAnswerOptions[0]?.score} />
          <TextBodyMedium bold ml={4} color="text.g2">
            {selectedAnswerOptions[0]?.score}/{answerOptions?.length}
          </TextBodyMedium>
        </Flex>
      </Flex>
    ),
  },
  [REVIEW_ANSWER_TYPE_MAP.NUMBER_RATING]: {
    component: ({ selectedAnswerOptions = [], answerOptions = [] }) => (
      <Flex flexDir="column">
        <TextLabel bold color="text.g2">
          Assessment
        </TextLabel>
        <ResultScaleRating data={answerOptions} selectedId={selectedAnswerOptions[0]?.id} />
      </Flex>
    ),
  },
};

const ResultRenderer = ({
  answerType,
  answerOptions,
  feedbackText,
  feedbackTextHtml,
  enableFeedbackText,

  selectedAnswerOptions, // <- this is the already selected options which is coming from server, possible when user didn't fully submit the review
}) => {
  const answerTypeComp = ANSWER_TYPE_COMPONENTS[answerType]?.component;
  const showFeedbackPlainText = !feedbackTextHtml;
  const hasFeedbackText = feedbackText || feedbackTextHtml;
  return (
    <Grid templateColumns={{ base: '1fr', desktop: 'repeat(5, 1fr)' }}>
      {answerTypeComp && (
        <GridItem colSpan={2}>
          <AnswerContainer>
            <>
              {answerTypeComp({
                selectedAnswerOptions,
                answerOptions,
              })}
            </>
          </AnswerContainer>
        </GridItem>
      )}
      <GridItem colSpan={3}>
        {enableFeedbackText && (
          <Flex flexDir="column">
            <TextLabel bold color="text.g2">
              Comments
            </TextLabel>
            <TextBodyMedium mt="2px">
              {!hasFeedbackText && '-'}
              {hasFeedbackText && (showFeedbackPlainText ? feedbackText : parse(feedbackTextHtml ?? ''))}
            </TextBodyMedium>
          </Flex>
        )}
      </GridItem>
    </Grid>
  );
};

export { ResultRenderer };
